import RouterComponent from './routes/index';
import './App.css';

function App() {
  return (
    <div className="App">
      <RouterComponent />
    </div>
  );
}

export default App;
